import { getScrollTop, getToken, removeToken, setScrollTop, setToken } from '@/commons/utils/cookies';
import router, { resetRouter } from '@/router';
import store from '@/store';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

/**
 * 用户模块
 */
@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule {
    public userToken = getToken() || '';

    public pageScrollTop: number = getScrollTop() || 0;

    public showTipDialog: boolean = true;

    @Mutation
    public SET_USER_TOKEN(token: string) {
        this.userToken = token;
        setToken(token);
    }

    @Mutation
    public SET_PAGE_SCROLL_TOP(number: number) {
        this.pageScrollTop = number;
        setScrollTop(String(number));
    }

    @Mutation
    public SET_SHOW_TIP_DIALOG(flag: boolean) {
        this.showTipDialog = flag;
    }

    /**
     * 清除token
     */
    @Action({ rawError: true })
    public ResetToken() {
        removeToken();
        this.SET_USER_TOKEN('');
    }

    /**
     * 退出登录
     */
    @Action({ rawError: true })
    public async LogOut(toLogin: boolean = true) {
        resetRouter();
        if (this.userToken === '') {
            throw Error('LogOut: token is undefined!');
        }
        removeToken();
        this.SET_USER_TOKEN('');
        toLogin && await router.push({ name: 'login' });
    }

    // 重新登录
    @Action({ rawError: true })
    public async reLogin() {
        const webApp = `${process.env.VUE_APP_HOME_URL}`;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_CORP_ID}&redirect_uri=${encodeURIComponent(webApp)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    }
}

export const UserModule = getModule(User);
